export default __webpack_public_path__ + "static/media/mathias.e41e0b53.jpg";